import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
let fire;

if (typeof window !== `undefined`) {
  const firebaseConfig = {
    apiKey: "AIzaSyCO9zwt4yhaiQ0eRM-xNHHWvSiVaU95mP0",
    authDomain: "auth.readalong.io",
    databaseURL: "https://readalong-6ded2.firebaseio.com",
    projectId: "readalong-6ded2",
    storageBucket: "",
    messagingSenderId: "644469693921",
    appId: "1:644469693921:web:8be0c7c24e6a29687146a0",
    measurementId: "G-EQ0FBWG61L",
  };

  fire = firebase.initializeApp(firebaseConfig);
  if (window.location.hostname === "localhost") {
    firebase.auth().useEmulator("http://localhost:9099/");
    firebase.firestore().useEmulator("localhost", 8080);
    firebase.functions().useEmulator("localhost", 5001);
  }
}

export default fire;
